import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../store/selectors'
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core'
import { Person, Language, Work } from '@material-ui/icons'
import { useHistory, useLocation } from 'react-router'

const navigationItems = [
    {
        path: '',
        label: 'Projekte',
        icon: <Work/>
    },
    {
        path: 'languages',
        label: 'Sprachen',
        icon: <Language/>
    },
    {
        path: 'users',
        label: 'Benutzer',
        icon: <Person/>
    }
]

export default () => {
    const history = useHistory()
    const location = useLocation()
    const pathElements = location.pathname.split('/')
    let idx = 0
    if (pathElements.length > 1) {
        const main = pathElements[1]
        idx = navigationItems.findIndex(entry => entry.path === main)
    }
    const [currentValue, setCurrentValue] = useState(idx > 0 ? idx : 0)

    const userIsApplicationOwner = useSelector(getCurrentUser).isApplicationOwner

    useEffect(() => {
        const main = pathElements[1]
        idx = navigationItems.findIndex(entry => entry.path === main)
        setCurrentValue(idx)
    }, [location])

    return <Footer>
        {userIsApplicationOwner && <StyledBottomNavigation
            value={currentValue}
            onChange={(event, newValue) => {
                setCurrentValue(newValue)
            }}
            showLabels>
            {navigationItems.map((item, index) => (
                <BottomNavigationAction key={`nav_${index}`} label={item.label} icon={item.icon} onClick={() => {history.push(`/${item.path}`)}}/>
            ))}
        </StyledBottomNavigation>}
    </Footer>
}

const Footer = styled.div`
    display: flex;
    flex: 0 0 50px;
    background-color: #f2f2f2;
`

const StyledBottomNavigation = styled(BottomNavigation)`
    display: flex;
    flex-direction: row;
    width: 100%;
    background-color: #f2f2f2 !important;    
`



// WEBPACK FOOTER //
// ./src/layout/Footer.js